import { render, staticRenderFns } from "./BCXLinkedUser.vue?vue&type=template&id=5e5c317c"
import script from "./BCXLinkedUser.vue?vue&type=script&lang=ts"
export * from "./BCXLinkedUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports